<template>
  <div class="system-tip">
    <nf-confirm
      :show="!isDialog"
      :handle-save-btn-click="handleLogoutClick"
      scrollbar-h="360px"
      :is-cancel-btn="showClose"
      :show-close="false"
      :save-btn-text="saveBtnText"
      :width="300"
    >
      <div slot="title" class="title" />
      <div slot="content" class="content">
        <h3>我司承诺：</h3>
        <p>
          1.我公司提供的《运输协议》、运单信息、资质文件、授权文件和其他资料信息等真实、准确、完整、合法。《运输协议》和运单信息已包含：委托人名称、承运人名称、车牌号、车牌颜色、出发时间、到达时间、起始地点、目的地、发票信息、运费金额等。
        </p>
        <p>
          2.我公司及承运人均同意授权贵公司根据运单信息生成《运输协议》，我公司保证我公司及承运人认可《运输协议》的效力。我公司保证运单信息真实、准确，如运单信息造假，该运单及其对应的《运输协议》自动作废。
        </p>
        <p>
          3.实际承运人是ETC卡的持卡人或实际承运人非ETC卡持卡人但已经已取得ETC卡持卡人关于使用ETC卡的授权；实际承运人的通行费已由我公司支付；实际承运人同意将运输过程中产生的通行费发票直接开具给我公司且放弃对前述票据的任何权利，同意前述票据由我公司直接或通过第三方委托行云数聚（北京）科技有限公司进行相关业务服务。
        </p>
        <p>
          4.如因提供虚假资料、虚假承诺等产生的后果、风险和法律责任均与我公司承担；如因此导致贵平台损失的，我公司不可撤销地同意予以全额赔偿。
        </p>
      </div>
    </nf-confirm>
  </div>
</template>
<script>
import nfConfirm from '@/components/nf-confirm/index';
import { saveOptMark } from '@/api/javaApi';
import store from '@/store/index';
export default {
  components: {
    nfConfirm,
  },
  data() {
    return {
      showClose: false,
      saveBtnText: '我已同意',
    };
  },
  computed: {
    isDialog() {
      return store.state.isDialog;
    },
  },
  watch: {
    isDialog: {
      handler(val) {
        this.isDialog = val;
        console.log('nihao', this.isDialog);
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    async handleLogoutClick() {
      console.log(111);
      const { code } = await saveOptMark({
        type: 'driver_ys_contract',
      });
      if (code === 200) {
        this.$store.dispatch('getOptMarkStatus');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.system-tip {
  width: 100%;
  box-sizing: border-box;
  padding-right: 463px;
}
.content > p {
  margin-top: 10px;
}
.system-tip .title {
  height: 116px;
  background-image: url('../../../assets/images/tongzhi_background@2x.png');
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 100% 100%;
}
::v-deep .el-row--flex {
  justify-content: center !important;
}
::v-deep .el-dialog__header {
  padding: 0 !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-scrollbar {
  padding: 25px 60px !important;
}
.content h3 {
  color: #181818 !important;
  font-size: 20px;
}
.content p {
  margin-top: 30px;
  line-height: 24px;
}
::v-deep .el-button--primary {
  width: 280px !important;
}
</style>
